
  import React from "react"
  import Component from "/home/alice/abc/new-website-master/src/layouts/index.tsx"
  import data from "/home/alice/abc/new-website-master/.cache/json/layout-index.json"

  export default (props) => <Component {...props} {...data} />
  


// WEBPACK FOOTER //
// ./.cache/layouts/index.js